import React from 'react'
import {deleteSingleTag, updateSingleTag} from "../common/services/tag-data-service";
import {Link} from "react-router-dom";
import DeleteTag from "./delete-tag";
// import Link from "next/link";

const TagDetail = ({selectedTag, setSelectedTag, setSelectedTagRemoved}) => {

    const handleSelectTagChanges = async (event) => {
        const {name, value} = event.target;
        const tag = {...selectedTag};
        tag[name] = value;

        setSelectedTag(tag);
        await updateSingleTag(tag);
    }

    const removeTag = async () => {
        await deleteSingleTag(selectedTag);
        setSelectedTagRemoved(true);
    }

    return (
        <>

            <div className="flex justify-between mb-5">
                <div className="title-label">
                    {selectedTag?.startText}
                </div>

                <div className="float-right -mt-2">
                    <DeleteTag tag={selectedTag} removeTag={removeTag}/>
                </div>
            </div>

            <div className="overflow-y-scroll form-container">

                {selectedTag &&
                    <>
                        <div className="field-group-container">
                            <div className="field-container w-full">
                                <div className="field-label">Start Text</div>
                                <input type="text" placeholder="Start Text"
                                       id="startText"
                                       name="startText"
                                       value={selectedTag?.startText}
                                       onChange={handleSelectTagChanges}
                                       className="input-field w-full"/>
                            </div>

                            <div className="field-container w-full">
                                <div className="field-label">Text</div>
                                <input type="text" placeholder="Text"
                                       id="text"
                                       name="text"
                                       value={selectedTag?.text}
                                       readOnly={true}
                                       className="input-field read-only-field w-full"/>
                            </div>
                        </div>
                    </>
                }

            </div>
        </>
    )
}

export default TagDetail
